import React from 'react';
import { LogOut, Bell, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/");
    };

    return (
        <header className="h-16 bg-gray-900 border-b border-gray-800 flex items-center justify-between px-8 sticky top-0 z-10">
            <div className="flex items-center gap-4 flex-1">
                {/* <div className="relative w-64">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={18} />
                    <input 
                        type="text" 
                        placeholder="Search..." 
                        className="w-full bg-gray-800 border-none rounded-lg py-2 pl-10 pr-4 text-sm text-gray-200 focus:ring-2 focus:ring-blue-500 transition-all"
                    />
                </div> */}
            </div>

            <div className="flex items-center gap-6">
                <button className="text-gray-400 hover:text-white transition-colors relative">
                    <Bell size={20} />
                    <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full border-2 border-gray-900"></span>
                </button>
                
                <div className="h-8 w-px bg-gray-800"></div>
                
                <button 
                    onClick={handleLogout}
                    className="flex items-center gap-2 px-4 py-2 bg-red-600/10 hover:bg-red-600 text-red-500 hover:text-white rounded-lg transition-all duration-200 group"
                >
                    <LogOut size={18} className="group-hover:-translate-x-1 transition-transform" />
                    <span className="font-medium">Logout</span>
                </button>
            </div>
        </header>
    );
};

export default Header;
